import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { enTranslation, npTranslation } from "#constants/translations";

const i18nDebug = import.meta.env.VITE_I18N_DEBUG === "true";

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    debug: i18nDebug,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: enTranslation,
      np: npTranslation,
    },
  });
}

export default i18n;
